//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OddsTable from '../components/OddsTable'

export default {
    name: 'TotalGoal',
    components: {
        OddsTable
    }
}
